(function () {
  if (window.__cartAddAccInit) return;
  window.__cartAddAccInit = true;

  function selectedEntries(details) {
    var out = [];
    details.querySelectorAll('[data-cai-select]').forEach(function (sel) {
      if (!sel.value) return;
      var opt = sel.selectedOptions[0];
      if (!opt) return;
      // Skip options that were pre-selected because they're already in the cart.
      if (opt.getAttribute('data-cai-existing') === '1') return;
      var sku = opt.getAttribute('data-sku');
      if (!sku) return;
      out.push({ sku: sku, value: sel.value, label: sel.getAttribute('data-acc-label') || '' });
    });
    return out;
  }

  function refreshCartSection() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var url = window.location.pathname === (window.routes && window.routes.cart_url || '/cart')
      ? window.location.href
      : cartUrl + '?section_id=cart-drawer';
    if (document.querySelector('#main-cart-items') && window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(cartUrl + '?section_id=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.drawer__inner');
        var dst = document.querySelector('.drawer__inner');
        if (src && dst) dst.innerHTML = src.innerHTML;
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var clearBtn = e.target.closest('[data-cai-clear]');
    if (clearBtn) {
      e.preventDefault();
      var details = clearBtn.closest('.cart-add-acc');
      if (!details) return;
      details.querySelectorAll('[data-cai-select]').forEach(function (sel) { sel.value = ''; });
      return;
    }

    var saveBtn = e.target.closest('[data-cai-save]');
    if (!saveBtn) return;
    e.preventDefault();
    var details = saveBtn.closest('.cart-add-acc');
    if (!details) return;
    var parentVariant = details.getAttribute('data-parent-variant');
    var entries = selectedEntries(details);
    if (!entries.length) return;

    var products = window.hvacAccessoryProducts || {};
    var adds = entries.map(function (e) {
      var variant = products[e.sku];
      if (!variant) {
        console.warn('[hvac] cart add-more: no accessory product for SKU', e.sku);
        return Promise.resolve();
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: variant.id,
          quantity: 1,
          properties: {
            Accessory: e.label,
            _option: e.value,
            _parent_variant: String(parentVariant || '')
          }
        })
      });
    });

    saveBtn.disabled = true;
    saveBtn.textContent = 'Adding...';
    Promise.all(adds)
      .then(refreshCartSection)
      .catch(function (err) {
        console.error('[hvac] cart add-more error:', err);
        saveBtn.disabled = false;
        saveBtn.textContent = 'Add to Cart';
      });
  });
})();
